// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d2e20e56","540":"3b98155f"}[chunkId] + ".chunk.js";
};